import storeRef from "@/store/instance";
import { STATE_MODULES } from '@/store/state-modules';
import { ConfigMutations } from "@/store/modules/config/mutations";
import { generals } from "@puls/puls-general-utils";
import { Component } from "vue";
import ConfirmationModal from '@/components/modals/Confirmation.vue';
import { ImagesModal, ModalItem } from "@/models/AppConfig";
import { ConfigGetters } from "@/store/modules/config/getters";
import ImagesSlider from '@/components/modals/ImagesSlider.vue';
import FullscreenImages from '@/components/modals/FullscreenImages.vue'
import { CallbackFunction } from "../models/Common";

interface ModalComponentItem {
	callback?: CallbackFunction,
	component: Component | null
}

export interface ModalConfirmationOptions {
	title: string,
	message: string
}

class ModalManager {
	private modalMap = new Map<string, ModalComponentItem>();

	constructor () {
		window.addEventListener('keydown', (e: KeyboardEvent) => {
			if (e.key === 'Escape') {
				const lastModalUuid: string = storeRef.instance.getters[`${STATE_MODULES.CONFIG}/${ConfigGetters.LAST_MODAL_UUID}`]
				if (lastModalUuid) {
					storeRef.instance.commit(`${STATE_MODULES.CONFIG}/${ConfigMutations.CHANGE_MODAL_SHOW}`, { uuid: lastModalUuid, show: false })	
				}
			}
		})
	}

	deleteModal (uuid: string, payload: any) : void {
		const result = this.modalMap.get(uuid);
		if (result?.callback) {
			result.callback(payload);
			this.modalMap.delete(uuid);
		}
	}

	getComponent (uuid: string) : Component | null {
		const result = this.modalMap.get(uuid);
		return result?.component || null;
	}

	open (component: Component<any> | null, options: Partial<ModalItem> = {}, callback: CallbackFunction = () => {}) : string {
		const uuid = generals.generateUuid();
		this.modalMap.set(uuid, { callback, component });
		storeRef.instance.commit(`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_MODAL}`, {
			uuid,
			show: false,
			type: options.type || 0,
			...options
		});

		return uuid;
	}

	openFullscreen (component: Component<any>, options: Partial<ModalItem> = {}, callback: CallbackFunction = () => {}) : void { 
		this.open(component, { ...options, fullscreen: true }, callback)
	}

	openConfirmationModal (confirmation: ModalConfirmationOptions, callback: CallbackFunction) : void {
		this.open(ConfirmationModal, { confirmation }, callback);
	}

	openImagesModal (data: ImagesModal, callback: CallbackFunction): void { 
		this.open(ImagesSlider, { imagesData: data }, callback);
	}

	openFullscreenImages (image: string, callback: CallbackFunction): void {
		this.openFullscreen(FullscreenImages, { data: { imageSrc: image } }, callback);
	}

	openOverlay (callback?: CallbackFunction): string {
		return this.open(null, { type: 'overlay' }, callback)
	}
}

export default new ModalManager()
